// Generated by GitHub Copilot
import About from "../components/About";
import Contact from "../components/Contact";
import Hero from "../components/Hero";

/**
 * Render the dedicated home page content.
 *
 * @param {{
 *   identityConfig: Record<string, any>,
 *   aboutConfig: Record<string, any>,
 *   contactConfig: Record<string, any>,
 *   apiBaseUrl: string,
 *   profile: Record<string, any>,
 *   loading: boolean,
 *   error: string
 * }} props Component props.
 * @returns {JSX.Element} Home page section.
 */
function HomePage({ identityConfig, aboutConfig, contactConfig, apiBaseUrl, profile, loading, error }) {
    return (
        <>
            <Hero config={identityConfig} profile={profile} loading={loading} error={error} />
            <About config={{ ...aboutConfig, title: "Professional Summary" }} profile={profile} loading={loading} />
            <Contact config={contactConfig} apiBaseUrl={apiBaseUrl} profile={profile} loading={loading} />
        </>
    );
}

export default HomePage;
